"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMapboxVersionFromSemantic = (version) => `lieuu.v${version && version.replace(/\./g, '-')}`;
//# sourceMappingURL=index.js.map